// Modules
import { Action, createReducer, on } from '@ngrx/store';

// Interfaces
import { IAccidentDetail } from '@accidents/shared/interfaces/accidents';

// Actions
import * as DetailAccidentActions from '@accidents/store/actions/detail-accident.actions';

export interface AccidentDetailState {
  accident: IAccidentDetail;
  loadingAccident: boolean;
}

export const initialAccidentDetailState: AccidentDetailState = {
  accident: undefined,
  loadingAccident: false,
};

const AccidentDetailReducer = createReducer(
  initialAccidentDetailState,
  on(DetailAccidentActions.reset, () => initialAccidentDetailState),
  on(DetailAccidentActions.getAccidentDetailRequested, state => ({
    ...state,
    loadingAccident: true,
  })),
  on(DetailAccidentActions.getAccidentDetailResponse, (state, action) => ({
    ...state,
    accident: action.payload,
    loadingAccident: false,
  }))
);

export function reducer(
  state: AccidentDetailState | undefined,
  action: Action
): AccidentDetailState {
  return AccidentDetailReducer(state, action);
}
